module.exports = __webpack_public_path__ + "static/media/ilus-services-datadriven.4a506254.svg";